
import * as React from "react"
import { ScrollArea as ShadcnScrollArea } from "@/components/ui/scroll-area"
import { cn } from "@/lib/utils"

export interface EnhancedScrollAreaProps extends React.ComponentPropsWithoutRef<typeof ShadcnScrollArea> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedScrollArea = React.forwardRef<HTMLDivElement, EnhancedScrollAreaProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <ShadcnScrollArea ref={ref} className={cn(className)} {...props}>
        {children}
      </ShadcnScrollArea>
    );
  }
);
EnhancedScrollArea.displayName = "EnhancedScrollArea";

// Re-export the original component
export const ScrollArea = EnhancedScrollArea;
